import { cn } from '@utils/cn';

import COLORS from '@ui-component-library/styles/colors';

import { iconWrapperStyles } from './Icon.styles';
import type { IconProps } from './Icon.types';
import * as Icons from './lib';

export const ICON_SIZES = {
  xxxsmall: 2,
  xxsmall: 4,
  xsmall: 6,
  small: 12,
  medium: 16,
  large: 20,
  xlarge: 32,
  xxlarge: 64
};

export const Icon = ({
  name,
  size = 'medium',
  spacing = 'none',
  color,
  className,
  ...props
}: IconProps) => {
  const pixelSize = ICON_SIZES[size];

  const IconComponent = Icons[name];

  if (!IconComponent) {
    console.error(`Icon ${name} not found`);
    return null;
  }

  if (color) {
    console.error(
      `The "color" prop for Icon "${name}" is deprecated. Please use the className prop with "fill-${color}" instead.`
    );

    const colorProp = color ? COLORS[color as keyof typeof COLORS] : 'charcoal-500';

    return (
      <div
        className={cn(iconWrapperStyles({ spacing, size }), className)}
        style={{
          fill: colorProp
        }}
        {...props}
      >
        <IconComponent height={pixelSize} width={pixelSize} />
      </div>
    );
  }

  return (
    <div className={cn(iconWrapperStyles({ spacing, size }), className)} {...props}>
      <IconComponent height={pixelSize} width={pixelSize} />
    </div>
  );
};
